import { getToken } from "./authHelper";

export const fetchPutResponse = (apiEndpoint, requestBody) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return fetch(`${apiUrl}/${apiEndpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(requestBody),
  });
};

export const fetchGetResponse = (apiEndpoint) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return fetch(`${apiUrl}/${apiEndpoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

export const fetchHomeSuggestions = async ({ forceRefresh = false } = {}) => {
  const params = new URLSearchParams();
  if (forceRefresh) params.set("force_refresh", "true");

  const endpoint = params.toString()
    ? `conversation/home_suggestions?${params.toString()}`
    : "conversation/home_suggestions";

  const response = await fetchGetResponse(endpoint);
  if (!response.ok) {
    throw new Error(`Failed to fetch home suggestions: ${response.status}`);
  }

  return response.json();
};
